<!-- src/components/ezer/EzerWelcome.vue -->
<template>
  <div class="ezer-welcome">
    <div class="ezer-welcome__icon">
      <svg viewBox="0 0 48 48" width="48" height="48" fill="none">
        <circle cx="24" cy="24" r="22" fill="var(--ezer-gradient-start)" opacity="0.12"/>
        <path d="M24 8a10 10 0 0 1 10 10v2a10 10 0 0 1-5 8.66V32a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-3.34A10 10 0 0 1 14 20v-2a10 10 0 0 1 10-10z" fill="var(--ezer-primary)"/>
        <rect x="17" y="37" width="14" height="3" rx="1.5" fill="var(--ezer-primary)"/>
        <circle cx="20.5" cy="20" r="1.5" fill="white"/>
        <circle cx="27.5" cy="20" r="1.5" fill="white"/>
        <path d="M20 26c1.33 1.33 2.67 1.5 4 1.5s2.67-.17 4-1.5" stroke="white" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </div>

    <h3 class="ezer-welcome__greeting">Hi {{ userName }}!</h3>
    <p class="ezer-welcome__tagline">I'm <strong>Ezer AI</strong>, your scheduling assistant. Ask me anything or pick a suggestion below.</p>

    <!-- ══ Smart alert banners ══ -->
    <div v-if="alerts.length" class="ezer-alerts">
      <div class="ezer-alerts__header">
        <span class="ezer-alerts__label">Things that need your attention</span>
        <button class="ezer-alerts__dismiss" @click="$emit('dismiss-alerts')" title="Dismiss">
          <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg>
        </button>
      </div>
      <button
        v-for="alert in alerts"
        :key="alert.id"
        class="ezer-alert"
        :class="'ezer-alert--' + alert.priority"
        @click="$emit('send', alert.action)"
      >
        <span class="ezer-alert__icon material-icons">{{ alert.icon }}</span>
        <span class="ezer-alert__body">
          <span class="ezer-alert__title">{{ alert.title }}</span>
          <span class="ezer-alert__desc">{{ alert.description }}</span>
        </span>
        <svg class="ezer-alert__arrow" viewBox="0 0 16 16" width="14" height="14" fill="currentColor"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>
      </button>
    </div>

    <div class="ezer-welcome__sections">
      <div v-if="suggestions.questions?.length" class="ezer-welcome__group">
        <span class="ezer-welcome__group-label">
          <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor"><path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 10.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zM8 4a2.5 2.5 0 0 0-2.5 2.5.75.75 0 0 0 1.5 0 1 1 0 1 1 1.72.7l-.6.56A2 2 0 0 0 7.5 9.5a.75.75 0 0 0 1.5 0 .5.5 0 0 1 .15-.36l.6-.56A2.5 2.5 0 0 0 8 4z"/></svg>
          Questions
        </span>
        <button
          v-for="q in suggestions.questions"
          :key="q"
          class="ezer-chip ezer-chip--question"
          @click="$emit('send', q)"
        >{{ q }}</button>
      </div>

      <div v-if="suggestions.actions?.length" class="ezer-welcome__group">
        <span class="ezer-welcome__group-label">
          <svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor"><path d="M4.5 2A1.5 1.5 0 0 0 3 3.5v9A1.5 1.5 0 0 0 4.5 14h7a1.5 1.5 0 0 0 1.5-1.5V6.621a1.5 1.5 0 0 0-.44-1.06L9.44 2.44A1.5 1.5 0 0 0 8.378 2H4.5zm1 5.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75zm.75 2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3z"/></svg>
          Actions I can perform
        </span>
        <button
          v-for="a in suggestions.actions"
          :key="a"
          class="ezer-chip ezer-chip--action"
          @click="$emit('send', a)"
        >{{ a }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EzerWelcome',
  props: {
    userName: { type: String, default: 'there' },
    suggestions: { type: Object, default: () => ({ questions: [], actions: [] }) },
    alerts: { type: Array, default: () => [] },
  },
  emits: ['send', 'dismiss-alerts'],
}
</script>
